export const DEPARTMENT_TYPE_OPTIONS = [
  { text: "小児科", value: 1 },
  { text: "産婦人科", value: 2 },
  { text: "助産師", value: 3 },
];

export const CHILD_GENDER_OPTIONS = [
  { text: "男の子", value: 0 },
  { text: "女の子", value: 1 },
];

export const USER_INTEREST_OPTIONS = [
  { text: "家でのケアの方法", value: 1 },
  { text: "病院受診の目安", value: 2 },
  { text: "原因", value: 3 },
  { text: "薬の使い方", value: 4 },
  { text: "その他", value: 5 },
];

export const USER_AGE_RANK_OPTIONS = [
  { text: "-14歳", value: 1 },
  { text: "15-19歳", value: 2 },
  { text: "20-24歳", value: 3 },
  { text: "25-29歳", value: 4 },
  { text: "30-34歳", value: 5 },
  { text: "35-39歳", value: 6 },
  { text: "40-44歳", value: 7 },
  { text: "45-49歳", value: 8 },
  { text: "50-54歳", value: 9 },
  { text: "55-59歳", value: 10 },
  { text: "60歳-", value: 11 },
];

export const IN_PREGNANCY_OPTIONS = [
  { text: "妊娠中", value: "pregnant" },
  { text: "産後", value: "postpartum" },
  { text: "小中高生", value: "teens" },
  { text: "その他", value: "others" },
];

export const WEEKS_OF_PREGNANCY_RANK_OPTIONS = [
  { text: "-14週", value: 1 },
  { text: "15-21週", value: 2 },
  { text: "22-27週", value: 3 },
  { text: "28-33週", value: 4 },
  { text: "34-36週", value: 5 },
  { text: "37週-", value: 6 },
];

export const MONTHS_OF_POSTPARTUM_RANK_OPTIONS = [
  { text: "1ヶ月未満", value: 1 },
  { text: "1-3ヶ月", value: 2 },
  { text: "4-6ヶ月", value: 3 },
  { text: "7-11ヶ月", value: 4 },
  { text: "12-17ヶ月", value: 5 },
  { text: "18-23ヶ月", value: 6 },
  { text: "24ヶ月-", value: 7 },
];
